<template>
<v-container>
    <v-row>
        <SkillsCard :languages="frontends" title="Frontend Languages" />
        <SkillsCard :languages="backends" title="Backend Languages" />
        <SkillsCard :languages="databases" title="Database Languages" />
        <SkillsCard :languages="frameworks" title="Frameworks" />
        <SkillsCard :languages="additionals" title="Additional Technologies" />
        <SkillsCard :languages="tools" title="Tools & Editors" />
    </v-row>
</v-container>
</template>

<script>
import SkillsCard from "@/components/SkillsCard.vue";

export default {
    components: {
        SkillsCard
    },
    data() {
        return {
            frontends: [
                {"title": "Html5", "per": 90, "color": "green darken-3"},
                {"title": "Css3", "per": 70, "color": "blue darken-1"},
                {"title": "Javascript", "per": 65, "color": "red lighten-1"}
            ],
            backends: [
                {"title": "Python", "per": 90, "color": "green darken-3"},
                {"title": "PHP", "per": 70, "color": "blue darken-1"},
                {"title": "NodeJS", "per": 60, "color": "red lighten-2"}
            ],
            databases: [
                {"title": "MySQL", "per": 85, "color": "light-green darken-2"},
                {"title": "PostgreSQL", "per": 75, "color": "blue darken-3"},
                {"title": "MongoDB", "per": 55, "color": "red lighten-3"}
            ],
            frameworks: [
                {"title": "Django", "per": 85, "color": "light-green darken-2"},
                {"title": "Flask", "per": 80, "color": "light-green darken-2"},
                {"title": "VueJS", "per": 75, "color": "blue darken-1"},
                {"title": "ReactJS", "per": 60, "color": "red lighten-1"},
                {"title": "ExpressJS", "per": 55, "color": "red lighten-2"},
                {"title": "Laravel", "per": 40, "color": "red darken-3"}
            ],
            additionals: [
                {"title": "Pandas", "per": 60, "color": "red lighten-2"},
                {"title": "Matplotlib", "per": 60, "color": "red lighten-2"},
                {"title": "Numpy", "per": 55, "color": "red lighten-1"},
                {"title": "Docker", "per": 55, "color": "red lighten-1"},
                {"title": "Data Analysis", "per": 50, "color": "red lighten-1"},
                {"title": "Machine Learning", "per": 25, "color": "red accent-3"}
            ],
            tools: [
                {"title": "VS Code", "per": 90, "color": "green darken-3"},
                {"title": "Brackets", "per": 90, "color": "green darken-3"},
                {"title": "Jupyter Notebook", "per": 90, "color": "green darken-3"},
                {"title": "PyCharm", "per": 80, "color": "light-green darken-2"},
                {"title": "Sublime Text Editor", "per": 80, "color": "light-green darken-2"},
                {"title": "MS Office", "per": 80, "color": "light-green darken-2"}
            ]
        }
    }
}
</script>